import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { cdFetch } from "../api";
import {
  NiaOpportunityDataForVendorResponse,
  NiaOpportunityPeerGrowthBenchmark,
  NiaOpportunityResponse,
} from "../../services/interfaces/INiaOpportunity";

const getQueryParams = (vendor: string | null, commodity: string | null) => {
  let qParams = "";
  if (vendor && vendor.length > 0) {
    qParams += `vendor=${encodeURIComponent(vendor)}&`;
  }
  if (commodity && commodity.length > 0) {
    qParams += `commodity=${encodeURIComponent(commodity)}&`;
  }

  if (qParams.length > 0) {
    qParams = "?" + qParams.slice(0, -1);
  }

  return qParams;
};

export const useNiaOpportunityVendorsList = () => {
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.niaOpportunity],
    queryFn: () => getNiaOpportunityVendorsList(),
    staleTime: 20000,
  });
  const vendorsListResponse: NiaOpportunityResponse = data?.data?.data;
  return { vendorsListResponse, isVendorsListLoading: isLoading };
};

const getNiaOpportunityVendorsList = () => {
  const res = cdFetch(`/getNIAData`);
  return res;
};

export const useNiaOpportunityVendorDetails = (vendor: string | null) => {
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.niaOpportunity, vendor],
    queryFn: () => getNiaOpportunityVendorDetails(vendor),
    staleTime: 20000,
    enabled: vendor !== null,
  });
  const vendorDetailsResponse: NiaOpportunityDataForVendorResponse =
    data?.data?.data;
  return { vendorDetailsResponse, isVendorDetailsLoading: isLoading };
};

const getNiaOpportunityVendorDetails = (vendor: string | null) => {
  const queryParams = getQueryParams((vendor = vendor), null);
  const res = cdFetch(`/getNIADataForVendor${queryParams}`);
  return res;
};

export const useNiaOpportunityPeerBenchmarkDetails = (
  vendor: string | null,
  commodity: string | null,
  triggerApi: boolean
) => {
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.niaOpportunity, "peer", vendor, commodity],
    queryFn: () => getNiaOpportunityPeerBenchmarkDetails(vendor, commodity),
    staleTime: 20000,
    enabled: vendor !== null && commodity !== null && triggerApi,
  });
  const peerBenchmarkDetailsResponse: NiaOpportunityPeerGrowthBenchmark[] =
    data?.data?.data?.data;
  return {
    peerBenchmarkDetailsResponse,
    isPeerBenchmarkDetailsLoading: isLoading,
  };
};

const getNiaOpportunityPeerBenchmarkDetails = (
  vendor: string | null,
  commodity: string | null
) => {
  const queryParams = getQueryParams(
    (vendor = vendor),
    (commodity = commodity)
  );
  const res = cdFetch(`/getNIAPeerBenchmarkData${queryParams}`);
  return res;
};
